import { AppBranding } from '../../../../types/appBranding';
import { appBranding } from './Branding/Branding';
import React from 'react';
import StyledHeader, { LeftAlign } from './Header.styles';
import { Logo } from './Logo/Logo';
import { useWeaveThemeContext } from '../../theme/WeaveContext';
import useAppBranding from './useAppBranding';
export interface LoadingHeaderProps {
	branding?: AppBranding;
}

export const LoadingHeader = ({ branding = 'info360' }: LoadingHeaderProps) => {
	const _branding = useAppBranding(branding);

	const { isWeaveTheme, weaveThemeConsumer } = useWeaveThemeContext();
	const resolvedRoles = weaveThemeConsumer?.resolvedRoles;
	const backgroundColor =
		isWeaveTheme && resolvedRoles['menu.backgroundColor'];
	const textColor = isWeaveTheme && resolvedRoles['colorScheme.text.default'];

	return (
		<StyledHeader backgroundColor={backgroundColor} textColor={textColor}>
			<LeftAlign>
				<Logo {...appBranding[_branding]} />
			</LeftAlign>
		</StyledHeader>
	);
};

export default LoadingHeader;
